const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the add Images component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addCategories', ['Application', 'Categories', 'i18n', function (Application, Categories, i18n) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        onChange: '&?'
      },
      template: require('../../../templates/directives/cms/add-categories.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.contentInitializing = false;
        self.loading = true;
        self.directory = {};
        self.selections = {};
        self.topLevel = [];
        self.chosenCats = {};
        self.mainCategory;
        self.restricted = false;
        self.allOptions = [];


        self.restrictedOnChange = function() {
          if ($scope.onChange && !self.contentInitializing) {
            $scope.onChange();
          }
        };

        var restrictedGroup = Application.access.profile && Application.access.profile.permissions && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.content && Application.access.profile.permissions.admin.content.restrict_category_options && Application.access.profile.permissions.admin.content.allowed_categories || [];
        if (Application.access.profile && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.content && Application.access.profile.permissions.admin.content.restrict_category_options) {
          self.restricted = true;
        }

        // Watch for delayed content - watch will be removed when categories have been detected or chosen
        var contentWatch = $scope.$watch('content', function(newVal, oldVal) {
          if (!$scope.content || !$scope.content.linked_category) {
            return;
          }
          self.contentInitializing = true;

          if ($scope.content.linked_category.length) {
            for (var i = 0; i < $scope.content.linked_category.length; i++) {
              self.chosenCats[$scope.content.linked_category[i]] = true;
            }
          }
          setTimeout(function() {
            self.contentInitializing = false;
          }, 700);
        });

        // Watch chosen categories and update the content categories when changed
        $scope.$watch('categories.chosenCats', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }

          // Removes the watch on content
          contentWatch();
          $scope.content.linked_category = [];
          for (var key in self.chosenCats) {
            if (self.chosenCats[key]) {
              $scope.content.linked_category.push(key);
            }
          }
          if ($scope.onChange && !self.contentInitializing) {
            $scope.onChange();
          }
          self.contentInitializing = false;

        }, true);

        self.lineageTrail = function(id, type) {
          // Check if valid category
          var category = self.directory[id];
          if (!category || !category.level || typeof category.level !== 'number') {
            return;
          }

          // Get name and return if type is active
          var activeName = category.name;
          if (type === 'active') {
            return activeName;
          }

          // Set trail outside of parent function scope
          var trail = '';
          // Add the parent name to the trail and recurse until reaching level one
          function getParent(category) {
            if (!category.parent) {
              return;
            }

            var parent = self.directory[category.parent];
            trail = parent.name + ' > ' + trail;
            if (parent.level > 1) {
              getParent(parent);
            }
          };

          if (category.level > 1) {
            // begin recursion if necessary
            getParent(category);
          }

          // return lineage if type is set to lineage
          if (type === 'lineage') {
            return trail;
          } 

          // return lineage and active by default
          return trail + activeName;
        };

        self.select = function(id) {
          var category = self.directory[id];
          if (!category || !category.level) {
            return;
          }
          self.selections[category.level] = category;
          var start = category.level + 1;
          while (start < 4) {
            self.selections[start] = null;
            start++;
          }
        };

        self.showSelections = function() {
          if (!$scope.content || !$scope.content.linked_category || !$scope.content.linked_category.length) {
            return false;
          }
          if ($scope.content.linked_category.length > 1) {
            return true;
          }
          if (self.mainCategory && self.mainCategory._id && $scope.content.linked_category[0] === self.mainCategory._id) {
            return false;
          }
          return true;
        };

        self.initialize = function () {
          Categories.findForAdmin({fields: 'children,name,localized_names,level,parent', category: true}).$promise
          .then(function(cats) {
            cats = i18n.localize_categories(cats);

            for (var i = 0; i < cats.length; i++) {
              category = cats[i];
              if (self.restricted) {
                if (restrictedGroup.indexOf(category._id) !== -1) {
                  self.allOptions.push(category);
                }
              }

              if (!category.level || typeof category.level !== 'number') {
                continue;
              }

              if (category.level === 10) {
                self.mainCategory = category;
                continue;
              }

              self.directory[category._id] = category;
              if (category.level === 1) {
                self.topLevel.push(category._id);
              }

              if (self.chosenCats[category._id]) {
                self.directory[category._id].active = true;
              }
            }

            self.loading = false;
          });
        };

        self.initialize();
      }],
      controllerAs: 'categories'
    };
  }]);
